import { render, staticRenderFns } from "./ruleConfig.vue?vue&type=template&id=2177160a&scoped=true"
import script from "./ruleConfig.vue?vue&type=script&lang=js"
export * from "./ruleConfig.vue?vue&type=script&lang=js"
import style0 from "./ruleConfig.vue?vue&type=style&index=0&id=2177160a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2177160a",
  null
  
)

export default component.exports